import create from 'zustand/vanilla';
import { persist, createJSONStorage } from "zustand/middleware";
import sessionStore from "@/store/modules/sessionStore";

interface ExampleState {
    example1: string;
    example2: string;
    example3: string;
    option1?: string[];
    options2?: number;
}

export interface ExampleStore extends ExampleState {
    setStore: (session: ExampleState) => void;
    clearStore: () => void;
}

const initializeState: ExampleState = {
    example1: '',
    example2: '',
    example3: '',
    option1: [],
    options2: 0,
}

export const exampleStore = create<ExampleStore>((set) => ({
    ...initializeState,

    setStore: (state) => {
        const initState: ExampleState = {...initializeState};
        const nState: Record<string, any> = {};

        Object.entries(initState).forEach(([key, value]) => {
            nState[key] = state[key as keyof ExampleState] || value;
        })

        set((state) => nState);
    },

    clearStore: () => {
        set(initializeState);
    }
}));

const { getState, setState, subscribe, destroy } = exampleStore;

export default exampleStore;